/**
 * Participants API Module
 *
 * API calls for participant (Teilnehmer) management
 */

import { apiClient } from './client'
import type { ParticipantDto } from '@/types/api.types'

export const participantsApi = {
  /**
   * Get all participants
   */
  async getAll(): Promise<ParticipantDto[]> {
    const response = await apiClient.get<ParticipantDto[]>('/Participants')
    return response.data
  },

  /**
   * Get single participant by ID
   */
  async getById(id: number): Promise<ParticipantDto> {
    const response = await apiClient.get<ParticipantDto>(`/Participants/${id}`)
    return response.data
  },
}
